import { _ } from '@ngx-translate/core';

import type { PendingHire, PendingHireStage } from './pending-hires.model';

export interface PendingHireRow {
  hireId: string;
  name: string;
  statusLabel: string;
  waitingSince: { label: string; date: string } | null;
  actionLabel: string;
  isExpired: boolean;
  link: string[];
}

const byStage: Record<
  PendingHireStage,
  { statusLabel: string; waitingSinceLabel: string; actionLabel: string; isExpired: boolean }
> = {
  waiting_for_info: {
    statusLabel: _('Waiting for info'),
    waitingSinceLabel: _('Invited [time]'),
    actionLabel: _('Remind'),
    isExpired: false,
  },
  ready_for_contract: {
    statusLabel: _('Ready for contract'),
    waitingSinceLabel: _('Ready [time]'),
    actionLabel: _('Review'),
    isExpired: false,
  },
  sent_for_e_sign: {
    statusLabel: _('Sent for e-sign'),
    waitingSinceLabel: _('Sent [time]'),
    actionLabel: _('Remind'),
    isExpired: false,
  },
  contract_downloaded: {
    statusLabel: _('Contract downloaded'),
    waitingSinceLabel: _('Downloaded [time]'),
    actionLabel: _('Activate'),
    isExpired: false,
  },
  signature_expired: {
    statusLabel: _('E-sign request expired'),
    waitingSinceLabel: _('Sent [time]'),
    actionLabel: _('Resend'),
    isExpired: true,
  },
};

const isKnownStage = (stage: string): stage is PendingHireStage => Object.hasOwn(byStage, stage);

export const toPendingHireRow = (pendingHire: PendingHire): PendingHireRow | null => {
  // core can ship a stage before this build knows it; drop the row instead of breaking the widget.
  if (!isKnownStage(pendingHire.stage)) {
    return null;
  }

  const statusDetails = byStage[pendingHire.stage];

  return {
    hireId: pendingHire.hire_id,
    name: pendingHire.employee_name,
    statusLabel: statusDetails.statusLabel,
    waitingSince: pendingHire.counted_from
      ? { label: statusDetails.waitingSinceLabel, date: pendingHire.counted_from }
      : null,
    actionLabel: statusDetails.actionLabel,
    isExpired: statusDetails.isExpired,
    link: ['/hiring/new-hires', pendingHire.hire_id],
  };
};
